import type { GetStaticProps, GetServerSideProps } from "next";
import { ApiService } from "services/server";
import { Labs } from "views";
import { labPageNormalizer } from "utils/normalizer";
import { REVALIDATE_TIME } from "utils/constants";
import { checkEmpty } from "utils/newFunction";

function LabsPage({ data }) {
  return <Labs data={data} />;
}

// export const getStaticProps: GetStaticProps = async ({ locale }) => {
//   const apiService = new ApiService(locale);

//   const requests = [
//     apiService.getLabList(), // 0
//   ];

//   const response = await ApiService.multipleRequest(requests);

//   if (checkEmpty(...response)) {
//     throw new Error();
//   }
//   return {
//     props: {
//       data: labPageNormalizer(response?.[0]),
//     },
//     revalidate: REVALIDATE_TIME,
//   };
// };

export const getServerSideProps: GetServerSideProps = async ({ locale }) => {
  const apiService = new ApiService(locale);
  try {
    const requests = [];
    requests.push(apiService.getLabList()); // 0

    let response = [];
    try {
      response = await ApiService.multipleRequest(requests);
    } catch (e) {
      // console.log(`e`, e);
    }
    return {
      props: {
        data: labPageNormalizer(response?.[0]),
      },
    };
  } catch (err) {
    return {
      redirect: {
        destination: "/500",
        permanent: false,
      },
    };
  }
};

export default LabsPage;
